import { render, staticRenderFns } from "./SponsorsAdmin.vue?vue&type=template&id=38389552&scoped=true&"
import script from "./SponsorsAdmin.vue?vue&type=script&lang=js&"
export * from "./SponsorsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SponsorsAdmin.vue?vue&type=style&index=0&id=38389552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38389552",
  null
  
)

export default component.exports